export default {
  title: 'Construction Permits Issued',
  x_axis: 'Year',
  y_axis: 'Number of Permits',
  districts: {
    Alanya: 'Alanya',
    Konyaalti: 'Konyaaltı',
    Kemer: 'Kemer',
    Kepez: 'Kepez',
    Dosemealti: 'Döşemealtı',
    Finike: 'Finike'
  }
}
